import BlockyBoldText from "components/custom-texts/blocky-bold-text";
import { Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAppSelector } from "state/hooks";
import {
  getContestantColor,
  getGroupState,
  getTextColor,
} from "state/slices/group-slice";
import { isPoolClosed } from "utils/pool/is-pool-closed";
import { Entry } from "interfaces/entry.ts";
import useContestContestantPickAllowedCheck from "hooks/useContestEntryCheck.ts";
import BlockyHeavyText from "components/custom-texts/blocky-heavy-text";

interface Props {
  entry: Entry;
  wasClicked: boolean;
  handleContestantClick: (entry: any) => void;
  totalSeedDistribution: number;
  poolStatus: number;
  contestEntryId?: string;
}

const ContestantCard = ({
  entry,
  handleContestantClick,
  wasClicked,
  totalSeedDistribution,
  poolStatus,
  contestEntryId,
}: Props) => {
  const textColor = useAppSelector(getTextColor);
  const closedPool = isPoolClosed(poolStatus);
  const group = useAppSelector(getGroupState);
  const contestantColor = useAppSelector(getContestantColor);

  const { isPickAllowed } = useContestContestantPickAllowedCheck(
    entry.contestant_name,
    contestEntryId
  );

  const projectedWin =
    (entry.seed_distribution / totalSeedDistribution || 0) * 100;

  const openPoolStyles = {
    border: wasClicked ? "1px solid black" : "none",
    backgroundColor: wasClicked
      ? group.settings.secondary_color
      : contestantColor,
    color: wasClicked ? "black" : textColor,
    opacity: isPickAllowed ? 1 : 0.5,
    cursor: isPickAllowed ? "pointer" : "not-allowed",
  };

  const closedPoolStyles = {
    backgroundColor: "gray",
    opacity: 1,
    cursor: "default",
  };

  const conditionalStyles = isPoolClosed(poolStatus)
    ? closedPoolStyles
    : openPoolStyles;

  const cardComponent = (
    <Card
      key={entry.pool_entry_id}
      onClick={(e) => {
        e.preventDefault();
        if (isPickAllowed && !closedPool) {
          handleContestantClick(entry);
        }
      }}
      style={{
        padding: 3,
        paddingLeft: 5,
        paddingRight: 5,
        marginBottom: 5,
        ...conditionalStyles,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div style={{ maxWidth: "65%" }}>
          <BlockyHeavyText>{entry.contestant_name}</BlockyHeavyText>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: 12,
            width: 84,
          }}
        >
          <BlockyBoldText>{projectedWin.toFixed(1)}%</BlockyBoldText>
          <BlockyBoldText>{entry.odds.toFixed(1)}X</BlockyBoldText>
        </div>
      </div>
    </Card>
  );

  return !isPickAllowed ? (
    <OverlayTrigger
      placement="top"
      delay={{ show: 250, hide: 400 }}
      overlay={(props: any) => (
        <Tooltip id={`tooltip-${entry.pool_entry_id}`} {...props}>
          <div style={{ color: "red", fontSize: "0.8rem" }}>
            Already picked in this contest
          </div>
        </Tooltip>
      )}
    >
      <div>{cardComponent}</div>
    </OverlayTrigger>
  ) : (
    cardComponent
  );
};

export default ContestantCard;
